import { useParams } from "react-router-dom";
import VoucherBrandComponent from "src/Components/VoucherBrandsDetails";

export default function VoucherBrandLayout() {
  const { ID } = useParams();
  return (
    <VoucherBrandComponent ID={ID} />
  );
}
